import { useState, useEffect, useCallback } from 'react';
import BASE_URL from './config';

/**
 * Hook that polls for unread notification counts by type and by ride.
 * Returns { message: N, ride_join: N, byRide: { rideId: { message: N, ride_join: N } } }
 */
export default function useUnreadCounts() {
  const [counts, setCounts] = useState({ message: 0, ride_join: 0, byRide: {} });

  const fetchCounts = useCallback(() => {
    Promise.all([
      fetch(`${BASE_URL}/api/notifications/unread-counts`, { credentials: 'include' }).then(r => r.ok ? r.json() : null),
      fetch(`${BASE_URL}/api/notifications/unread-by-ride`, { credentials: 'include' }).then(r => r.ok ? r.json() : null),
    ])
    .then(([typeCounts, rideCounts]) => {
      setCounts({
        message: typeCounts?.message || 0,
        ride_join: typeCounts?.ride_join || 0,
        byRide: rideCounts || {},
      });
    })
    .catch(() => {});
  }, []);

  useEffect(() => {
    fetchCounts();
    const interval = setInterval(fetchCounts, 30000);
    return () => clearInterval(interval);
  }, [fetchCounts]);

  return { ...counts, refresh: fetchCounts };
}
